import { tr } from '@repo/locale';
import { type TestId } from '@repo/test-id';
import { DotsAnimation } from '@repo/ui';

interface Props {
  testId: TestId;
}

export default function PleaseWaitAnimation({ testId }: Props) {
  return (
    <div
      className="text-heading m-auto flex flex-col items-center gap-3 text-base"
      data-testid={testId.append('pleaseWait')}
    >
      <DotsAnimation size="lg" />
      <div>{tr('loading.fetching_data')}</div>
    </div>
  );
}
